<template>
  <chart-card :loading="loading" :title="$t(keyMessage[productSoldType].all)"
              :total="productSoldData.total">
    <a-tooltip :title="$t('message.views.workbench.dashboardDescription.totalOrderQuantity')" slot="action">
      <a-icon type="info-circle-o"/>
    </a-tooltip>
    <div>
      <a-row>
        <a-col :span="12">
          <trend :flag="getTrendFlag(productSoldData.quantityThisWeek - productSoldData.quantityLastYearThisWeek)">
            <span slot="term">{{ $t('message.views.workbench.wow') }}</span>
            {{ Math.abs(Math.floor((productSoldData.quantityThisWeek - productSoldData.quantityLastYearThisWeek) / productSoldData.quantityLastYearThisWeek * 10000)) / 100 }}%
          </trend>
        </a-col>
        <a-col :span="12">
          <trend :flag="getTrendFlag(productSoldData.quantityToday - productSoldData.quantityLastYearToday)" style="margin-right: 16px;">
            <span slot="term">{{ $t('message.views.workbench.dod') }}</span>
            {{ Math.abs(Math.floor((productSoldData.quantityToday - productSoldData.quantityLastYearToday) / productSoldData.quantityLastYearToday * 10000)) / 100 }}%
          </trend>
        </a-col>
      </a-row>
    </div>
    <template slot="footer">
      {{ $t(keyMessage[productSoldType].daily) }}<span style="margin-left:10px">{{productSoldData.quantityToday}}</span></template>
  </chart-card>
</template>

<script>
import request from '../../../utils/request'
import formatMoney from '../../../utils/numberUtil'
import {
  ChartCard,
  MiniArea,
  Trend
} from '../../../components'
const keyMessage = {
  ITEM_SOLD: {
    all: 'message.views.workbench.totalItemSold',
    daily: 'message.views.workbench.dailyItemSold'
  },
  ORDER_QUANTITY: {
    all: 'message.views.workbench.totalOrderQuantity',
    daily: 'message.views.workbench.dailyOrderQuantity'
  }
}
export default {
  name: 'ProductSoldYoyCard',
  components: {
    ChartCard,
    MiniArea,
    Trend
  },
  data () {
    return {
      productSoldData: {},
      keyMessage,
      loading: true
    }
  },
  props: {
    productSoldType: {
      type: String,
      default: 'ITEM_SOLD'
    }
  },
  mounted () {
    this.getProductSoldData()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  },
  methods: {
    getProductSoldData () {
      request({
        url: '/dashboard/getProductSoldYoyData',
        method: 'get',
        params: {
          productSoldDataType: this.productSoldType
        }
      }).then(response => {
        // response.data = json
        this.productSoldData = response.data.model
      })
    },
    getTrendFlag (value) {
      if (value > 0) {
        return 'up'
      } else if (value < 0) {
        return 'down'
      } else {
        return ''
      }
    },
    formatMoney
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/ProductSoldYoyCard.vue